export default "__VITE_ASSET__C6qqTSXW__"